<template>
  <b-modal
      :visible="visible"
      id="admin-new-company-pricing-plan-modal"
      ref="modal"
      title="Assign new Pricing Plan"
      hide-footer
      centered
  >
    <b-form @submit.prevent="submitForm">
      <b-form-group label="What type of Pricing Plan?">
        <b-form-select
            v-model="formData.type"
            :options="planTypeOptions"
            :state="fieldValid('type')"
        />
      </b-form-group>

      <b-form-group v-if="formData.type.length > 0" label="Select Pricing Plan">
        <b-spinner v-if="loadingPlans"/>
        <h4 v-if="availablePlanOptions.length === 0" class="ml-0">No available plan to assign</h4>
        <b-form-select
            v-else
            v-model="formData.pricing_plan"
            :options="availablePlanOptions"
            :state="fieldValid('pricing_plan')"
        />
      </b-form-group>

      <b-button
          v-if="formData.type.length > 0 && formData.pricing_plan"
          type="submit"
          variant="primary"
          :disabled="formState.processing"
      >
        Assign new Pricing Plan
        <b-spinner v-if="formState.processing" class="ml-1" small></b-spinner>
      </b-button>
      <b-btn type="button" variant="secondary" @click.prevent="close">Cancel</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import {API_ROUTES} from "../api";
import {getFormattedPrice} from "../helpers";

export default {
  name: "AdminNewCompanyPricingPlanModal",
  emits: ['created'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentPlans: Array,
    companyId: Number
  },
  data() {
    return {
      loadingPlans: true,
      planTypeOptions: [
        {value: 'membership', text: 'Membership (access to platform)'},
        {value: 'add-on', text: 'For a hub (add-on to membership)'}
      ],
      formData: {
        type: '',
        pricing_plan: null
      },
      formState: {
        processing: false
      },
      formValidation: {},
      allPlans: []
    }
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'admin-new-company-pricing-plan-modal');
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-new-company-pricing-plan-modal');
    },
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    submitForm() {
      this.formState.processing = true;
      this.$api.post(`${API_ROUTES.ADMIN_PRICING_PLANS}/assign`, {
        company: this.companyId,
        pricing_plan: this.formData.pricing_plan
      }).then(({data}) => {
        this.$bvToast.toast('Pricing plan has been successfully assigned', {
          title: 'Success!',
          variant: 'success'
        });
        this.formValidation = {};
        this.$emit('created', data.company_plans);
      }).catch(({response: {data}}) => {
        this.$bvToast.toast(data.message ?? 'Failed to assign a pricing plan', {
          title: 'Error!',
          variant: 'danger'
        });
        let validationErrors = {};
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in data.errors) {
            validationErrors[fieldName] = data.errors[fieldName].join(', ');
          }
        }
        this.formValidation = validationErrors;
      }).finally(() => {
        this.formState.processing = false;
      })
    }
  },
  computed: {
    availablePlanOptions() {
      let plans = this.allPlans.filter(
          p => this.currentPlans.length === 0 || !this.currentPlans.find(cp => cp.id === p.id)
      );
      if (this.formData.type.length > 0) {
        if (this.formData.type === 'membership') {
          plans = plans.filter(p => p.type.code === 'membership');
        } else if (this.formData.type === 'add-on') {
          plans = plans.filter(p => p.type.code === 'add-on');
        }
      }

      return plans.map(p => {
        let price = p.is_free ? 'FREE' : getFormattedPrice(p.amount);

        return {
          value: p.id,
          text: `${p.name} - ${price}`
        }
      });
    }
  },
  created() {
    this.$api.get(API_ROUTES.ADMIN_PRICING_PLANS).then(({data}) => {
      this.allPlans = data.pricing_plans;
    }).catch(({response: {data}}) => {

    }).finally(() => {
      this.loadingPlans = false;
    })
  },
  watch: {
    'formData.type': function () {
      this.formData.pricing_plan = null;
    }
  }
}
</script>
